import {Button, Dialog, DialogTitle} from '@mui/material';
import EventBulletIcon from '@icons/EventBulletIcon';
import Picker from 'react-mobile-picker';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

interface IProps {
	date: Date;
	setDate: (day: Date) => void;
}

export default function CalendarButtons({date: d, setDate}: IProps) {
	const [openYearPicker, setOpenYearPicker] = useState(false);
	const [openMonthPicker, setOpenMonthPicker] = useState(false);
	const {t} = useTranslation();
	const date = new Date(d);
	const year = date.toLocaleDateString('fa-IR', {year: 'numeric'});
	const month = date.toLocaleDateString('fa-IR', {month: 'long'});
	const months = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];
	const years = ['۱۳۹۵', '۱۳۹۶', '۱۳۹۷', '۱۳۹۸', '۱۳۹۹', '۱۴۰۰', '۱۴۰۱', '۱۴۰۲', '۱۴۰۳', '۱۴۰۴'];
	const handlePrevClicked = () => {
		date.setDate(date.getDate() - 30);
		setDate(date);
	};
	
	const handleNextClicked = () => {
		date.setDate(date.getDate() + 30);
		setDate(date);
	};
	
	const handleOpenYearPicker = () => {
		setOpenYearPicker(true);
	};
	
	const handleCloseYearPicker = () => {
		setOpenYearPicker(false);
	};
	
	const handleOpenMonthPicker = () => {
		setOpenMonthPicker(true);
	};
	
	const handleCloseMonthPicker = () => {
		setOpenMonthPicker(false);
	};
	
	const handleChangeYear = (name: string, value: string) => {
		// @ts-ignore
		const prevYear = Number(year.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));
		// @ts-ignore
		const nextYear = Number(value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)));
		date.setFullYear(date.getFullYear() - (prevYear - nextYear));
		setDate(date);
	};
	
	const handleChangeMonth = (name: string, value: string) => {
		date.setMonth(date.getMonth() - (months.indexOf(month) - months.indexOf(value)));
		setDate(date);
	};
	
	
	return (
		<div className="flex flex-row space-x-2 rtl:space-x-reverse mx-4">
			<Button
				className="h-8 p-0 round-no-text-button"
				sx={{borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'grey.800'}}
				style={{minWidth: 32}}
				variant="outlined"
				onClick={handlePrevClicked}
				startIcon={<EventBulletIcon flip/>}/>
			<Button
				className="grow h-8 p-0"
				sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper',
					color: (theme) => theme.palette.mode === 'light' ? 'grey.700' : 'grey.200'
				}}
				onClick={handleOpenYearPicker}
				variant="outlined">
				{year}
			</Button>
			<Button
				className="grow h-8 p-0 "
				sx={{
					borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : theme.palette.grey[700],
					bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.A200' : 'background.paper',
					color: (theme) => theme.palette.mode === 'light' ? 'grey.700' : 'grey.200'
				}}
				onClick={handleOpenMonthPicker}
				variant="outlined">
				{month}
			</Button>
			<Button
				className="h-8 p-0 round-no-text-button"
				sx={{borderColor: (theme) => theme.palette.mode === 'light' ? 'grey.100' : 'grey.800'}}
				style={{minWidth: 32}}
				variant="outlined"
				onClick={handleNextClicked}
				startIcon={<EventBulletIcon/>}/>
			
			<Dialog onClose={handleCloseYearPicker} open={openYearPicker}>
				<DialogTitle>{t('change_year')}</DialogTitle>
				<Picker
					valueGroups={{title: year}}
					optionGroups={{title: years}}
					onChange={handleChangeYear}/>
			</Dialog>
			<Dialog onClose={handleCloseMonthPicker} open={openMonthPicker}>
				<DialogTitle>{t('change_month')}</DialogTitle>
				<Picker
					valueGroups={{title: month}}
					optionGroups={{title: months}}
					onChange={handleChangeMonth}/>
			</Dialog>
		</div>
	);
}
